document.addEventListener('DOMContentLoaded', function() {
    // Alterar o texto "Tipo de Produto" para "O que você busca?"
    document.querySelectorAll('.filter-title').forEach(title => {
        if (title.textContent.trim() === 'Tipo de Produto') {
            title.textContent = 'O que você busca?';
        }
    });

    // Substituir ícone de telefone pelo ícone do WhatsApp
    const iconElement = document.querySelector('.bls__footer-infor .picon-earphones');
    if (iconElement) {
        const newIconElement = document.createElement('span');
        newIconElement.className = 'fs-26 about-support-icon picon-whatsapp';
        newIconElement.style.cssText = 'font-family:presslayouts-font;color:#25D366;';
        iconElement.replaceWith(newIconElement);
    }

   function isMobile() {
        return window.innerWidth <= 768; // Define mobile como largura menor ou igual a 768px
    }

    window.addEventListener("scroll", function () {
        let checkoutButton = document.querySelector("#checkoutympButton");
        if (checkoutButton) {
            if (isMobile() && window.scrollY > 30) { // Adiciona classe após 30px de scroll
                checkoutButton.classList.add("scrolled-btn");
            } else {
                checkoutButton.classList.remove("scrolled-btn"); // Remove classe ao voltar para o topo
            }
        }
    });
  
});

